<!--
 * @Description: 待支付订单-批次列表-修改弹层
 * @Date: 2021-04-29 15:54:00
-->
<template>
  <div>
    <table-render
      ref="tableRender"
      :config="config"
      height="45vh"
      width="80vw"
      rowKey="orderNumber"
    />
    <the-footer :params="delParams" />
  </div>
</template>

<script>
import tableRender from '@/components/tableRender';
import { editPayProject } from '../config';

export default {
  name: 'EditPayProject',
  cname: '修改项目',
  props: ['row'],
  data() {
    return {
      config: null,
      selection: []
    };
  },
  computed: {
    delParams() {
      let map = {
        1: 4,
        2: 3,
        3: 3
      };

      let threeIds = this.selection
        .filter(i => {
          return map[i['projectStructureType']] == 3;
        })
        .map(j => j.id)
        .toString();

      let fourIds = this.selection
        .filter(i => {
          return map[i['projectStructureType']] == 4;
        })
        .map(j => j.id)
        .toString();
      const { id } = this.row;
      return {
        csoCustomOrderId: id,
        threeIds,
        fourIds
      };
    }
  },
  components: {
    tableRender,
    // functional:true,
    theFooter: {
      props: {
        params: {
          type: Object,
          default: function() {
            return {};
          }
        }
      },
      render(h) {
        return h(
          'div',
          {
            style: {
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '10px 50px'
            }
          },
          [
            h(
              'el-button',
              {
                on: {
                  click: () => {
                    this.$parent.$emit('confirm');
                    this.$xrkDialog.remove();
                  }
                }
              },
              ['关闭']
            )
          ]
        );
      }
    }
  },
  created() {
    editPayProject[0].childMenu[0].defaultQuery = {
      batchOrderId: this.row.id
    };
    this.config = editPayProject;
  }
};
</script>
